import styled from "styled-components";
export const DatePickerPopperWrapper = styled.div `
  [data-popper-placement^="top"] & {
    min-height: 350px;
  }
`;
